import { Layout_WithUser } from '@components/WithUser/WithUser';
import { SignUp } from 'app-next/onboarding/business/signup/page';
import type { NextPageWithLayout } from 'pages/_app';

const SignUpPage: NextPageWithLayout = () => <SignUp />;

SignUpPage.getLayout = (page) => {
  return <Layout_WithUser redirect={false}>{page}</Layout_WithUser>;
};

export default SignUpPage;
